import api from '../../../utils/api';

export interface FetchEmailNotificationSettingsResponse {
    communicationPreferences: {
        agencyId: string;
        viewingNotificationRecipientGroup: string;
        viewingPlannedNotificationEnabled: boolean;
        viewingRejectedNotificationEnabled: boolean;
        viewingRescheduledNotificationEnabled: boolean;
        viewingAttendanceListEnabled: boolean;
    }
}

export interface EmailNotificationSettingsFormData {
    agencyId: string;
    viewingNotificationRecipientGroup: string;
    viewingPlannedNotificationEnabled: string;
    viewingRejectedNotificationEnabled: string;
    viewingRescheduledNotificationEnabled: string;
    viewingAttendanceListEnabled: string;
}

const mapResponseToFormData = (response: FetchEmailNotificationSettingsResponse) => {
    return {
        agencyId: response.communicationPreferences.agencyId,
        viewingNotificationRecipientGroup: response.communicationPreferences.viewingNotificationRecipientGroup,
        viewingPlannedNotificationEnabled: response.communicationPreferences.viewingPlannedNotificationEnabled.toString(),
        viewingRejectedNotificationEnabled: response.communicationPreferences.viewingRejectedNotificationEnabled.toString(),
        viewingRescheduledNotificationEnabled: response.communicationPreferences.viewingRescheduledNotificationEnabled.toString(),
        viewingAttendanceListEnabled: response.communicationPreferences.viewingAttendanceListEnabled.toString(),
    };
}

const fetchEmailNotificationSettings = async (selectedAgencyId: string, signal: AbortSignal): Promise<EmailNotificationSettingsFormData> => {
    const reponse: FetchEmailNotificationSettingsResponse = await api.get(`api/agency/${selectedAgencyId}/preferences/communication/get`, {}, signal);
    return mapResponseToFormData(reponse);

};

export default fetchEmailNotificationSettings;
